<template>
  <div class="big">
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="doctorId"
      :visitType="visitType"
      :visitName="visitName"
      :sms_type="3"
      :activeIndexDia="activeIndexDia"
    ></ReturnVisit>
    <!-- 修改手机弹窗 -->
    <modify-phone
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :doctor_id="doctor_id"
      :phone="info.phone"
      @getDetail="getDetail"
    ></modify-phone>
    <div class="page_title flex between">
      <span>
        <span>医生信息详情</span>
        <el-button
          type="primary"
          style="width: 80px; margin-left: 20px"
          size="medium"
          @click="toReturn"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1315') : false
          "
          >回访</el-button
        >
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="tem_title">医生信息</div>
        <div class="box flex_wrap">
          <div>
            <span class="title">医生姓名</span>
            <span>{{ info.doctor_name }}</span>
          </div>
          <div>
            <span class="title">医生手机号</span>
            <span>{{ info.phone }}</span>
            <el-link
              @click="editPhone"
              type="primary"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1531') : false
              "
              style="padding: 0 0 4px 4px"
              >修改</el-link
            >
          </div>
          <div>
            <span class="title">医生注册时间</span>
            <span>{{ info.create_time }}</span>
          </div>
          <div>
            <span class="title">来源</span>
            <span v-if="info.doc_from == 1">APP注册</span>
            <span v-if="info.doc_from == 2">平台注册</span>
            <span v-if="info.doc_from == 3">邀请注册</span>
            <span v-if="info.doc_from == 4">外部注册【SaaS】</span>
          </div>
          <div>
            <span class="title">最后登录时间</span>
            <span>{{ info.last_pre_time }}</span>
          </div>
          <div>
            <span class="title">最后登录地址</span>
            <span>{{ info.province_name }}{{ info.city_name }}</span>
          </div>
          <div>
            <span class="title">APP版本号</span>
            <span>{{ info.version }}</span>
          </div>
          <div>
            <span class="title">设备名称</span>
            <span>{{ info.device_name }}</span>
          </div>
          <div>
            <span class="title">设备型号</span>
            <span>{{ info.device_model }}</span>
          </div>
          <div>
            <span class="title">系统版本</span>
            <span>{{ info.system_version }}</span>
          </div>
          <div>
            <span class="title">绑定歧黄助手</span>
            <template v-if="info.wx_openid">
              <span style="margin-right: 10px">{{
                info.wx_nick_name ? info.wx_nick_name : "已绑定"
              }}</span>
              <el-button
                type="primary"
                size="mini"
                @click="unbindWechatBtn"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1544') : false
                "
                >解除绑定</el-button
              >
            </template>
            <template v-else>未绑定</template>
          </div>
        </div>
        <div class="tem_title">消息配置</div>
        <div class="box">
          <div>
            <span class="title">医生开方客服接收</span>
            <el-input
              maxlength="200"
              v-model="setting_msg.doc_remark"
              style="width: 300px; margin-right: 10px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('755') : false
              "
            ></el-input>
            <el-button
              type="primary"
              @click="addRemark"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('755') : false
              "
              >添加</el-button
            >
          </div>
          <div style="padding-left: 200px; color: #ff7440; margin-bottom: 10px">
            医生开方后，附加推送此备注信息
          </div>
          <div>
            <span class="title">药房处方打印显示</span>
            <el-input
              maxlength="200"
              v-model="setting_msg.hospital_print_remark"
              style="width: 300px; margin-right: 10px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('807') : false
              "
            ></el-input>
            <el-button
              type="primary"
              @click="addPrintRemark"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('807') : false
              "
              >添加</el-button
            >
          </div>
        </div>

        <div class="tem_title">开方配置</div>
        <div class="box">
          <span class="title">新标剂量转换设置</span>
          <span>
            <el-radio-group
              v-model="setting_msg.national_standard"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1748') : false
              "
              @change="setNationalStandard"
            >
              <el-radio :label="1">开启自动转换新标药材剂量</el-radio>
              <el-radio :label="0">关闭自动转换新标药材剂量</el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";
import modifyPhone from "@/components/modifyPhone";
import common from "@/api/common";
import doctor from "@/api/doctor";
export default {
  name: "Msg",
  data() {
    return {
      doctor_id: this.$route.query.doctor_id,
      info: {},
      setting_msg: {},
      doctorId: 0,
      return_visit: false,
      visitName: "doctor",
      visitType: 1,
      activeIndexDia: "1",
      dialogVisible: false,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    ReturnVisit,
    modifyPhone,
  },
  created() {
    this.getDetail();
  },
  methods: {
    // 解除绑定
    unbindWechatBtn() {
      this.$confirm("确认解除绑定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          common
            .unbindWechat({ doctor_id: this.$route.query.doctor_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("解除成功");
                this.getDetail();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    getDetail() {
      let doctor_id = this.$route.query.doctor_id;
      this.axios
        .post("platform/Doctor/getDoctorDetail", { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.info = res.data.deviceid_msg;
            this.setting_msg = res.data.setting_msg;
            this.info.create_time = this.info.create_time
              ? dayjs.unix(this.info.create_time).format("YYYY-MM-DD HH:mm:ss")
              : "";
            this.info.timestamp = this.info.timestamp
              ? dayjs.unix(this.info.timestamp).format("YYYY-MM-DD HH:mm:ss")
              : "";
          }
        });
    },
    // 设置医生开方备注
    addRemark() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        doc_remark: this.setting_msg.doc_remark,
      };
      this.axios.post("platform/doctor/setDoctorRemark", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 设置药房打印显示
    addPrintRemark() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        hospital_print_remark: this.setting_msg.hospital_print_remark,
      };
      this.axios
        .post("platform/doctor/setHospitalPrintRemark", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    // 设置新标药材剂量修改确认弹框是否开启
    setNationalStandard() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        national_standard: this.setting_msg.national_standard,
      };
      doctor.setNationalStandard(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
        }
        this.getDetail();
      });
    },
    back() {
      history.back();
    },
    //回访
    toReturn() {
      this.doctorId = this.$route.query.doctor_id;
      this.return_visit = !this.return_visit;
    },
    // 修改手机号
    editPhone() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 40px 24px 24px 32px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.tem_title {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 10px;
}
.title {
  color: #333;
  font-weight: 600;
  width: 180px;
  display: inline-block;
  text-align: right;
  margin-right: 20px;
}

.box {
  border: solid 1px #cfcece;
  padding: 14px 0;
  box-sizing: border-box;
  margin-bottom: 50px;
}
.flex_wrap {
  display: flex;
  flex-wrap: wrap;
  div {
    width: 40%;
    margin-bottom: 16px;
  }
  div:last-child {
    margin-bottom: 0px;
  }
}
</style>